import styled from "styled-components";

export const NavContainer = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 80px;
  position: sticky;
  top: 0px;
  background: #ffffff;
  z-index: 1;
  @media screen and (max-width: 1024px) {
    padding: 0px 32px;
    height: 70px;
  }
`;
export const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1em;
`;
export const NavLogo = styled.img`
  height: 39px;
  // width: 116px;
  // margin-right: 20px;
  &:hover {
    cursor: pointer;
  }
`;
export const Menu = styled.ul`
  display: flex;
  justify-content: center;
  gap: 3em;
  padding-inline-start: 0px;
  @media screen and (max-width: 1024px) {
    gap: 1.5em;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const MenuItem = styled.li`
  /* margin-right: 49px; */
  /* background-color: #2B2C3E; */
  // width:176px;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    text-decoration: none;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #2b2c3e;
    width: fit-content;
    &:hover {
      font-weight: 700;
    }
  }
  a.active {
    font-weight: 700 !important;
  }

  @media screen and (max-width: 1024px) {
    a {
      font-size: 14px;
    }
  }
`;

export const ButtonContainer = styled.div`
  /* width: 30%; */
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const MobileMenu = styled.div`
  /* width: 30%; */
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
  }

  button {
    background: none;
    border: none;
    outline: none;
  }
  button.menubtn {
    background: none;
    border: none;
    outline: none;
    font-size: 30px;
  }
  .mobile {
    &_container {
      height: 100vh;
      width: 80%;
      background: #ffffff;
      position: absolute;
      left: ${(props) => (props.open ? "0" : "-110%")};
      top: 0;
      box-shadow: 84px 0px 0px 0px rgba(0, 0, 0, 0.22);
      padding: 120px 55px;
      overflow: hidden;
      transition: all ease-in-out 0.3s;
    }
    &_close {
      height: 30px;
      width: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #e7e8e5;
      color: #ffffff;
      font-size: 30px;
      position: absolute;
      top: 30px;
      right: 30px;
    }
    &_menu {
      display: flex;
      flex-flow: column;
      align-items: center;
      ul {
        width: 100%;
        padding: 0;
        margin-top: 100px;
        li {
          margin-bottom: 44px;
          a {
            font-family: Poppins;
            font-size: 17px;
            font-weight: 500;
            line-height: 26px;
            letter-spacing: 0em;
            text-align: left;
          }
        }
      }
    }
  }
`;
